import {
  LOCALE_ID,
  NgModule,
  ErrorHandler,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { environment } from '@env/environment';
import { environment as environmentIr } from '@env/environment.ir';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ENV_TOKEN, TEXT_DIRECTION_TOKEN, VIEW_TOKEN } from './app.tokens';

import { MobileBadgeModule } from '@app/shared/modules/mobile-badge/mobile-badge.module';
import { AppView } from '@app/core/enums/app-view.enum';
import { BrowserModule } from '@angular/platform-browser';
import { ThemeService } from './core/services/theme.service';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { MediaMatcherService } from './core/services/media-matcher.service';
import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule, AppRoutingModule, MobileBadgeModule, BrowserModule],
  providers: [
    ThemeService,
    MediaMatcherService,
    provideHttpClient(withXhr()),
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
    {
      provide: TEXT_DIRECTION_TOKEN,
      useFactory: (localeId: string) => (localeId === 'fa-IR' ? 'rtl' : 'ltr'),
      deps: [LOCALE_ID],
    },
    {
      provide: ENV_TOKEN,
      useValue: window.location.origin.includes('.ir')
        ? environmentIr
        : environment,
    },
    {
      provide: VIEW_TOKEN,
      useFactory: () => {
        const viewInUrl = new URLSearchParams(window.location.search).get(
          'view'
        );
        const targetView =
          viewInUrl?.toLowerCase() === AppView.Embedded
            ? AppView.Embedded
            : AppView.Default;
        return targetView;
      },
    },
    {
      provide: LOCALE_ID,
      useFactory: () => {
        const pathname = window.location.pathname;
        const regexp = new RegExp(
          `(?<=\\/)\\b([a-z]{2,3}-[a-z]{2,3})\\b(?=\\/)`,
          'i'
        );
        const match = pathname.match(regexp);
        return match ? match[0] : 'ru-RU';
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
